/* ==========================================================================
   AMARA · slider del hero

   Funde una imagen sobre otra cada N segundos. Se detiene:
     - mientras el cursor está encima (solo ratón: en el móvil un toque
       dispara un «mouseenter» que nunca termina y lo dejaba parado);
     - mientras el foco del teclado está dentro, para poder leer;
     - si la pestaña no está a la vista, para no gastar batería;
     - y no arranca solo si el sistema pidió movimiento reducido: ahí se
       queda la primera imagen y los puntos siguen funcionando.

   Si alguien toca un punto, el pase se reinicia desde esa imagen.
   ========================================================================== */

(function () {
  'use strict';

  var MINIMO = 2500;
  var POR_DEFECTO = 5000;

  function iniciar(raiz) {
    if (raiz.dataset.amSliderBound) return;
    raiz.dataset.amSliderBound = '1';

    var slides = raiz.querySelectorAll('[data-am-slide]');
    var dots = raiz.querySelectorAll('[data-am-dot]');
    if (slides.length < 2) return;

    var ms = Math.max(MINIMO, parseFloat(raiz.dataset.interval) || POR_DEFECTO);
    var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var actual = 0;
    var timer = null;
    var pausado = false;

    function ir(n) {
      n = (n + slides.length) % slides.length;
      if (n === actual) return;
      slides[actual].classList.remove('is-active');
      slides[actual].setAttribute('aria-hidden', 'true');
      if (dots[actual]) dots[actual].removeAttribute('aria-current');
      actual = n;
      slides[actual].classList.add('is-active');
      slides[actual].removeAttribute('aria-hidden');
      if (dots[actual]) dots[actual].setAttribute('aria-current', 'true');
    }

    function parar() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function arrancar() {
      parar();
      if (quieto || pausado || document.hidden) return;
      timer = setInterval(function () { ir(actual + 1); }, ms);
    }

    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () {
        ir(parseInt(d.dataset.amDot, 10));
        arrancar();
      });
    });

    raiz.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      pausado = true;
      parar();
    });
    raiz.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      pausado = false;
      arrancar();
    });
    raiz.addEventListener('focusin', function () { pausado = true; parar(); });
    raiz.addEventListener('focusout', function () { pausado = false; arrancar(); });
    document.addEventListener('visibilitychange', arrancar);

    // Deslizar con el dedo.
    //
    // Antes bastaba un desplazamiento horizontal de 40 px, sin mirar el
    // vertical, y eso convertía en swipe cualquier scroll de la página que
    // empezara sobre la foto: el pulgar sube 300 px y se desvía 50 de lado,
    // y el slider lo leía como «imagen anterior», o sea la última. De ahí la
    // secuencia que se veía en el móvil: primera, última, primera y ya el
    // pase normal.
    //
    // Ahora el gesto tiene que ser claramente horizontal, y con un solo
    // dedo: un pellizco para acercar la foto no cambia de imagen.
    var DESPLAZAMIENTO = 40;
    var DOMINANCIA = 1.5;
    var x0 = null;
    var y0 = null;

    function olvidar() {
      x0 = null;
      y0 = null;
    }

    raiz.addEventListener('touchstart', function (e) {
      if (e.touches.length > 1) {
        olvidar();
        return;
      }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });

    raiz.addEventListener('touchcancel', olvidar);

    raiz.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      olvidar();
      if (Math.abs(dx) < DESPLAZAMIENTO) return;
      // Más vertical que horizontal: era un scroll, no un swipe.
      if (Math.abs(dx) < Math.abs(dy) * DOMINANCIA) return;
      ir(actual + (dx < 0 ? 1 : -1));
      arrancar();
    });

    // En el editor de temas, al seleccionar un bloque de imagen el slider
    // salta a esa imagen y se queda quieto, para poder editarla viéndola.
    document.addEventListener('shopify:block:select', function (e) {
      var i = Array.prototype.indexOf.call(slides, e.target);
      if (i === -1) return;
      pausado = true;
      parar();
      ir(i);
    });
    document.addEventListener('shopify:block:deselect', function () {
      pausado = false;
      arrancar();
    });

    arrancar();
  }

  function todos(dentro) {
    Array.prototype.forEach.call((dentro || document).querySelectorAll('[data-am-slider]'), iniciar);
  }

  todos();

  // El editor de temas vuelve a pintar la sección cuando se cambia algo.
  document.addEventListener('shopify:section:load', function (e) { todos(e.target); });
})();
